/* [BD] Experts section — video play only when details is open (bd-experts.liquid) */
;(function () {
  function pauseExpertsVideo(videoDetails) {
    var video = videoDetails.querySelector('video');
    if (!video) return;
    video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {
      /* ignore seek errors before metadata */
    }
  }

  function resetExpertsVideoDetails(videoDetails) {
    if (videoDetails.hasAttribute('open')) {
      videoDetails.removeAttribute('open');
    }
    pauseExpertsVideo(videoDetails);
  }

  function bindExpertsVideo(videoDetails) {
    if (!videoDetails || videoDetails.dataset.bdExpertsVideoBound === '1') return;
    videoDetails.dataset.bdExpertsVideoBound = '1';

    resetExpertsVideoDetails(videoDetails);

    var video = videoDetails.querySelector('video');
    if (video) {
      video.autoplay = false;
      video.removeAttribute('autoplay');
      if (!video.hasAttribute('preload')) {
        video.setAttribute('preload', 'none');
      }
    }

    videoDetails.addEventListener('toggle', function () {
      var vid = videoDetails.querySelector('video');
      if (!vid) return;

      if (videoDetails.open) {
        var playPromise = vid.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } else {
        pauseExpertsVideo(videoDetails);
      }
    });
  }

  function getExpertsScrollOffset(sectionEl) {
    var custom = parseInt(sectionEl.getAttribute('data-bd-experts-scroll-offset'), 10);
    if (!isNaN(custom) && custom > 0) {
      return custom;
    }
    var header = document.querySelector('sticky-header');
    if (header && header.offsetHeight) {
      return header.offsetHeight + 16;
    }
    return 16;
  }

  function normalizeClassToken(raw) {
    return String(raw || '')
      .trim()
      .replace(/^\./, '')
      .split(/\s+/)[0];
  }

  function resolveScrollTarget(type, value) {
    if (!value) return null;
    if (type === 'id') {
      var id = String(value).trim().replace(/^#/, '');
      return document.getElementById(id);
    }
    if (type === 'class') {
      var token = normalizeClassToken(value);
      if (!token) return null;
      try {
        return document.querySelector('.' + token);
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function scrollToExpertsTarget(target, sectionEl) {
    if (!target) return false;
    var offset = getExpertsScrollOffset(sectionEl);
    var top = target.getBoundingClientRect().top + window.scrollY - offset;
    var reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: Math.max(0, top),
      left: 0,
      behavior: reducedMotion ? 'auto' : 'smooth',
    });
    if (typeof target.focus === 'function') {
      try {
        target.focus({ preventScroll: true });
      } catch (e) {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        target.removeAttribute('tabindex');
      }
    }
    return true;
  }

  function setActiveNavLink(nav, activeLink) {
    if (!nav || !activeLink) return;
    nav.querySelectorAll('.bd-experts__nav-item--active').forEach(function (item) {
      item.classList.remove('bd-experts__nav-item--active');
    });
    nav.querySelectorAll('.bd-experts__nav-link--active').forEach(function (link) {
      link.classList.remove('bd-experts__nav-link--active');
    });
    var item = activeLink.closest('.bd-experts__nav-item');
    if (item) item.classList.add('bd-experts__nav-item--active');
    activeLink.classList.add('bd-experts__nav-link--active');
  }

  function hideInvalidNavLinks(nav) {
    if (!nav) return;

    nav.querySelectorAll('[data-bd-experts-scroll][data-bd-experts-target]').forEach(function (link) {
      var type = link.getAttribute('data-bd-experts-scroll');
      var value = link.getAttribute('data-bd-experts-target');
      var target = resolveScrollTarget(type, value);
      var item = link.closest('.bd-experts__nav-item');

      if (!item) return;

      if (!target) {
        item.hidden = true;
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('tabindex', '-1');
      } else {
        item.hidden = false;
        link.removeAttribute('aria-hidden');
        link.removeAttribute('tabindex');
      }
    });
  }

  function bindExpertsNav(sectionEl) {
    var nav = sectionEl.querySelector('.bd-experts__nav');
    if (!nav || nav.dataset.bdExpertsNavBound === '1') return;
    nav.dataset.bdExpertsNavBound = '1';
    hideInvalidNavLinks(nav);

    nav.addEventListener('click', function (event) {
      var link = event.target.closest('[data-bd-experts-scroll]');
      if (!link || !nav.contains(link)) return;

      event.preventDefault();

      var type = link.getAttribute('data-bd-experts-scroll');
      var value = link.getAttribute('data-bd-experts-target');
      var target = resolveScrollTarget(type, value);

      if (!target) return;

      if (scrollToExpertsTarget(target, sectionEl)) {
        setActiveNavLink(nav, link);
        if (window.history && window.history.replaceState) {
          var hash = type === 'id' ? '#' + String(value).trim().replace(/^#/, '') : '';
          if (hash) {
            window.history.replaceState(null, '', hash);
          }
        }
      }
    });
  }

  function initBdExpertsSection(root) {
    if (!root) return;
    root.querySelectorAll('[data-experts-video]').forEach(bindExpertsVideo);
    bindExpertsNav(root);
  }

  function onReady() {
    document.querySelectorAll('[data-bd-experts-section]').forEach(initBdExpertsSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      initBdExpertsSection(e.target);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target) return;
      var nav = e.target.querySelector('.bd-experts__nav');
      if (nav) delete nav.dataset.bdExpertsNavBound;
      e.target.querySelectorAll('[data-experts-video]').forEach(function (videoDetails) {
        pauseExpertsVideo(videoDetails);
        delete videoDetails.dataset.bdExpertsVideoBound;
      });
    });

    document.addEventListener('shopify:block:select', function () {
      document.querySelectorAll('[data-bd-experts-section] [data-experts-video]').forEach(resetExpertsVideoDetails);
    });
  }
})();
